<template>
  <AppModal ref="modal" :stacked="true" @close="$emit('close')" @clickaway="close">
    <template slot="modal-header">
      <h3 class="font-weight-medium">
        Course Aliases
      </h3>
    </template>
    <template slot="modal-body">
      <div v-if="tempValue.filter(a => a).length">
        <div class="d-flex mb-2">
          <div class="flex-1">Subject Code</div>
          <div class="flex-1">Course Number</div>
        </div>
        <div v-for="(alias, index) in tempValue" :key="index">
          <FormCourseAlias
            v-if="alias"
            class="mb-2 flex-1"
            v-bind="{ value: alias, inline, config, aliases: tempValue }"
            @input="setAlias(index, $event)"
            @deleting="deleteAlias(index)"
          />
        </div>
      </div>
      <div v-else class="text-center text-muted my-4">
        No aliases added
      </div>
      <AppButton :raised="true" @click="addAlias">
        <AppIcon name="add" />
        Add Alias
      </AppButton>
    </template>
    <template slot="modal-footer">
      <AppButton @click="close">Close</AppButton>
    </template>
  </AppModal>
</template>

<script>
import FormCourseAlias from '../FormCourseAlias'
import _clonedeep from 'lodash/cloneDeep'

export default {
  components: { FormCourseAlias },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => ({ type: 'text' }),
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return { tempValue: {} }
  },
  created () {
    this.tempValue = _clonedeep(this.value || [])
  },
  methods: {
    close () {
      this.$refs.modal.close()
      this.$emit('close')
    },
    update () {
      this.$emit('update', this.tempValue.filter(alias => alias && alias.subjectCode && alias.courseNumber))
    },
    addAlias () {
      this.tempValue.push({})
    },
    deleteAlias (index) {
      this.tempValue.splice(index, 1, undefined)
      this.update()
    },
    setAlias (index, value) {
      this.tempValue.splice(index, 1, value)
      this.update()
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: unset;
  max-height: 100%;
}
</style>
